import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import BlockRenderer from "@/components/brand/BlockRenderer";

export default function PublicViewer() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [pageId, setPageId] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/public/brands/${slug}`);
        setData(data);
        if (data.pages?.length) setPageId(data.pages[0].id);
      } catch {
        setData({ error: true });
      }
    })();
  }, [slug]);

  if (!data) return <div className="min-h-screen flex items-center justify-center">Laden…</div>;
  if (data.error) return <div className="min-h-screen flex items-center justify-center">Merk niet gevonden</div>;

  const activePage = data.pages.find((p) => p.id === pageId);

  return (
    <div className="min-h-screen flex bg-[#e8e4e1] text-[#3a372b]">
      <aside className="w-72 shrink-0 h-screen sticky top-0 bg-[#e8e4e1] border-r border-[#858370]/25 p-6 flex flex-col">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-full" style={{ background: data.brand.color_accent || "#fe7f57" }} />
          <div>
            <div className="font-display text-lg leading-none">{data.brand.name}</div>
            <div className="text-xs text-[#858370]">{data.brand.tagline}</div>
          </div>
        </div>
        <div className="text-xs uppercase tracking-widest text-[#858370] mb-3">Pagina's</div>
        <nav className="space-y-1 bh-scroll overflow-y-auto">
          {data.pages.map((p) => (
            <button
              key={p.id}
              data-testid={`viewer-page-${p.id}`}
              onClick={() => setPageId(p.id)}
              className={`w-full text-left px-4 py-2 rounded-lg text-sm ${
                p.id === pageId ? "bg-[#fecbc6] text-[#3a372b] font-medium" : "hover:bg-[#858370]/10"
              }`}
            >
              {p.name}
            </button>
          ))}
        </nav>
        <div className="mt-auto text-xs text-[#858370]">Alleen-lezen weergave.</div>
      </aside>
      <main className="flex-1 overflow-y-auto bh-scroll">
        {activePage && (
          <div className="max-w-5xl mx-auto p-12">
            {activePage.blocks.map((b) => (
              <BlockRenderer key={b.id} block={b} editMode={false} />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
